import { FC } from 'react';

import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';

import { SET_FORM_DATA, SET_STEP, STEP_FLOW, STEP_AUTH_ERROR, DispatchType } from './reducer';

type Props = {
    dispatch: DispatchType;
};

const IFramedPromoPartnershipLogin: FC<Props> = ({ dispatch }) => {
    return authModalLoader.loadAuthContent({
        action: authModalLoader.constants.REGISTER,
        flow: authModalLoader.constants.EMBEDDED_PROMO_FLOW,
        onAuthComplete: (data: $TSFixMe) => {
            if (data?.userId) {
                dispatch({ type: SET_FORM_DATA, formData: { userId: data.userId } });
                dispatch({
                    type: SET_STEP,
                    step: STEP_FLOW,
                });
            } else {
                dispatch({ type: SET_STEP, step: STEP_AUTH_ERROR });
            }
        },
    });
};

export default IFramedPromoPartnershipLogin;
